/**
 * Enhanced Wishlist — localStorage + AJAX Product Fetching
 * Fixes the collections.all 50-product limit by fetching product data via AJAX.
 * Also manages wishlist count badge in the header.
 */
;(function (Wishlist, $) {

  /* ───── State ─────────────────────────────────────────────────────────── */
  var wishlist = [];

  function getWishlist() {
    try {
      var stored = localStorage.getItem('user_wishlist');
      if (stored && stored.length > 0) {
        return JSON.parse(stored);
      }
    } catch (e) {}
    return [];
  }

  function saveWishlist() {
    localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
  }

  /* ───── Money Formatting (lazy, same approach as cart page) ────────── */
  function getMoneyFormat() {
    return window.moneyFormat || '{{amount}}';
  }

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;

    var formatStr = getMoneyFormat();
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatStr.match(placeholderRegex);
    if (!match) return cents;

    function fmtDel(number, precision, thousands, decimal) {
      precision = (typeof precision === 'undefined') ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var p = parts[1] ? (decimal + parts[1]) : '';
      return d + p;
    }

    var value = '';
    switch (match[1]) {
      case 'amount': value = fmtDel(cents, 2); break;
      case 'amount_no_decimals': value = fmtDel(cents, 0); break;
      case 'amount_with_comma_separator': value = fmtDel(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmtDel(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmtDel(cents, 2, "'", '.'); break;
      default: value = fmtDel(cents, 2);
    }

    return formatStr.replace(placeholderRegex, value);
  }

  /* ───── Badge Update ──────────────────────────────────────────────────── */
  function updateBadge() {
    var count = wishlist.length;
    // Desktop badge
    var $dBadge = $('.mh-wishlist-badge');
    if (count > 0) {
      $dBadge.text(count).show();
    } else {
      $dBadge.hide();
    }
    // Mobile badge
    var $mBadge = $('.mh-mob-wishlist-badge');
    if (count > 0) {
      $mBadge.text(count).show();
    } else {
      $mBadge.hide();
    }
  }

  /* ───── Toggle Wishlist (from product grid/page) ──────────────────── */
  var animateWishlist = function (self) {
    $(self).toggleClass('is-active');
  };

  var updateWishlist = function (self) {
    var productHandle = $(self).attr('data-product-handle');
    var isRemove = $(self).hasClass('is-active');

    if (isRemove) {
      // Remove from wishlist
      var removeIndex = wishlist.indexOf(productHandle);
      if (removeIndex > -1) {
        wishlist.splice(removeIndex, 1);
        saveWishlist();
      }
      toastr.info('Product removed from wishlist.');
    } else {
      // Add to wishlist
      if (wishlist.indexOf(productHandle) === -1) {
        wishlist.push(productHandle);
        saveWishlist();
      }
      toastr.success('Product added to wishlist.');
    }
    updateBadge();
  };

  /* ───── Activate Existing Wishlist Buttons ────────────────────────── */
  var activateItemsInWishlist = function () {
    $('.wishlist-btn').each(function () {
      var productHandle = $(this).attr('data-product-handle');
      if (wishlist.indexOf(productHandle) > -1) {
        $(this).addClass('is-active');
      }
    });
  };

  /* ───── Wishlist Page: AJAX Loading ───────────────────────────────── */
  var loadWishlistPage = function () {
    // Only run on the wishlist page
    if (window.location.href.indexOf('pages/wishlist') === -1) return;

    var $loading = $('.enhanced-wishlist__loading');
    var $items = $('.enhanced-wishlist__items');
    var $empty = $('.enhanced-wishlist__empty');
    var $content = $('.enhanced-wishlist__content');
    var $footer = $('.enhanced-wishlist__footer');

    if (wishlist.length === 0) {
      $loading.hide();
      $content.hide();
      $empty.show();
      $footer.hide();
      return;
    }

    // Fetch all products in parallel
    var requests = [];
    var validHandles = [];

    $.each(wishlist, function(i, handle) {
      var req = $.ajax({
        url: '/products/' + handle + '.js',
        dataType: 'json',
        timeout: 8000
      }).then(
        function(data) {
          // .js endpoint returns the product object directly (not wrapped in "product" key)
          // and includes 'available' on both product and variant levels
          return { handle: handle, product: data };
        },
        function() {
          // Failed (404 = deleted product) — mark for cleanup
          return $.Deferred().resolve({ handle: handle, product: null }).promise();
        }
      );
      requests.push(req);
    });

    $.when.apply($, requests).done(function() {
      var results = requests.length === 1 ? [arguments[0]] : $.makeArray(arguments);
      var hasItems = false;

      $.each(results, function(i, result) {
        if (result && result.product) {
          renderWishlistItem(result.product, $items);
          validHandles.push(result.handle);
          hasItems = true;
        } else if (result && result.handle) {
          // Product was deleted — clean up localStorage
          var idx = wishlist.indexOf(result.handle);
          if (idx > -1) wishlist.splice(idx, 1);
        }
      });

      // Save cleaned wishlist
      saveWishlist();
      updateBadge();

      // Show content
      $loading.hide();
      if (hasItems) {
        $content.show();
        $footer.show();
      } else {
        $content.hide();
        $empty.show();
        $footer.hide();
      }
    });
  };

  /* ───── Render Single Wishlist Item ───────────────────────────────── */
  function renderWishlistItem(product, $container) {
    var variant = product.variants[0];
    // .js endpoint always includes 'available' at both product and variant level
    var available = product.available;
    var imgSrc = '';

    // .js endpoint: product.featured_image is a URL string; product.images is an array of URL strings
    // .json endpoint: product.image is an object with .src; product.images is an array of objects with .src
    if (product.featured_image) {
      imgSrc = product.featured_image;
    } else if (product.image && typeof product.image === 'string') {
      imgSrc = product.image;
    } else if (product.image && product.image.src) {
      imgSrc = product.image.src;
    } else if (product.images && product.images.length > 0) {
      imgSrc = (typeof product.images[0] === 'string') ? product.images[0] : product.images[0].src;
    }
    // Resize via Shopify CDN
    if (imgSrc) {
      imgSrc = imgSrc.replace(/(\.[a-z]+)(\?|$)/, '_200x200_crop_center$1$2');
    }

    var priceHtml = formatMoney(variant.price);
    var comparePriceHtml = '';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      comparePriceHtml = '<span class="enhanced-wishlist__price-compare">' + formatMoney(variant.compare_at_price) + '</span>';
    }

    var availHtml = available
      ? '<span class="enhanced-wishlist__availability in-stock">In Stock</span>'
      : '<span class="enhanced-wishlist__availability out-of-stock">Sold Out</span>';

    var addCartBtn = available
      ? '<button type="button" class="enhanced-wishlist__add-cart js-wl-add-cart" data-variant-id="' + variant.id + '" data-product-handle="' + product.handle + '">' +
        '<i class="fa fa-shopping-cart"></i> Add To Cart' +
        '</button>'
      : '<button type="button" class="enhanced-wishlist__add-cart" disabled>' +
        'Sold Out' +
        '</button>';

    var vendorHtml = product.vendor
      ? '<div class="enhanced-wishlist__vendor">' + product.vendor + '</div>'
      : '';

    var html = '<li class="enhanced-wishlist__item" data-handle="' + product.handle + '">' +
      '<div class="enhanced-wishlist__product">' +
        '<a href="/products/' + product.handle + '" class="enhanced-wishlist__thumb">' +
          '<img src="' + imgSrc + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" loading="lazy" />' +
        '</a>' +
        '<div class="enhanced-wishlist__details">' +
          '<a href="/products/' + product.handle + '" class="enhanced-wishlist__product-title">' + product.title + '</a>' +
          vendorHtml +
          availHtml +
          '<div class="enhanced-wishlist__mobile-price">' + priceHtml + comparePriceHtml + '</div>' +
        '</div>' +
      '</div>' +
      '<div class="enhanced-wishlist__price">' + priceHtml + comparePriceHtml + '</div>' +
      '<div class="enhanced-wishlist__actions">' +
        addCartBtn +
        '<button type="button" class="enhanced-wishlist__remove js-wl-remove" data-product-handle="' + product.handle + '" title="">' +
          '<i class="fa fa-times"></i>' +
        '</button>' +
      '</div>' +
    '</li>';

    $container.append(html);
  }

  /* ───── Remove from Wishlist Page ─────────────────────────────────── */
  function removeFromPage(handle) {
    var $item = $('.enhanced-wishlist__item[data-handle="' + handle + '"]');
    $item.addClass('is-removing');

    setTimeout(function() {
      $item.remove();
      // Remove from array
      var idx = wishlist.indexOf(handle);
      if (idx > -1) wishlist.splice(idx, 1);
      saveWishlist();
      updateBadge();

      // Also deactivate any wishlist buttons with this handle on the page
      $('.wishlist-btn[data-product-handle="' + handle + '"]').removeClass('is-active');

      // Check if empty
      if ($('.enhanced-wishlist__item').length === 0) {
        $('.enhanced-wishlist__content').hide();
        $('.enhanced-wishlist__footer').hide();
        $('.enhanced-wishlist__empty').show();
      }
    }, 400);
  }

  /* ───── Add to Cart from Wishlist ──────────────────────────────────── */
  function addToCartFromWishlist(variantId, $btn) {
    var originalText = $btn.html();
    $btn.html('<i class="fa fa-spinner fa-spin"></i> Adding...').prop('disabled', true);

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { id: variantId, quantity: 1 },
      dataType: 'json',
      success: function() {
        $btn.html('<i class="fa fa-check"></i> Added!');
        // Update header cart count
        $.getJSON('/cart.js', function(cart) {
          $('.txt_number').html(cart.item_count);
          $('.mh-cart-badge, #cart-total-badge').text(cart.item_count).show();
          $('.mh-mob-cart-badge, #mob-cart-badge').text(cart.item_count).show();
        });
        toastr.success('Product added to cart');
        // Reset button after 2s
        setTimeout(function() {
          $btn.html(originalText).prop('disabled', false);
        }, 2000);
      },
      error: function() {
        $btn.html(originalText).prop('disabled', false);
        toastr.error('Could not add to cart. Please try again.');
      }
    });
  }

  /* ───── Event Binding ─────────────────────────────────────────────── */
  var bindUIActions = function () {
    // Wishlist toggle buttons (on product grids/pages)
    $(document).on('click', '.wishlist-btn', function (e) {
      e.preventDefault();
      updateWishlist(this);
      animateWishlist(this);
    });

    // Remove from wishlist page
    $(document).on('click', '.js-wl-remove', function (e) {
      e.preventDefault();
      var handle = $(this).attr('data-product-handle');
      removeFromPage(handle);
    });

    // Add to cart from wishlist page
    $(document).on('click', '.js-wl-add-cart', function (e) {
      e.preventDefault();
      var variantId = $(this).attr('data-variant-id');
      addToCartFromWishlist(variantId, $(this));
    });
  };

  /* ───── Initialize ────────────────────────────────────────────────── */
  Wishlist.init = function () {
    wishlist = getWishlist();
    bindUIActions();
    activateItemsInWishlist();
    updateBadge();
    loadWishlistPage();
  };

}(window.Wishlist = window.Wishlist || {}, jQuery));